<template>
    <DropMenu
        :menu-state.sync="menuOpen"
        :items="users"
        :menu-props="{
            'open-on-hover': false,
            'nudge-left': 50,
            'attach': true,
            'transition': false,
            'offset-y': true
        }"
        multi
        deselect
        name-key="name"
        value-key="id"
        :show-selected-first="false"
        searchable
        avatars
        avatar-initials-key="initials"
        :avatar-circular-rule-func="() => false"
        :search-text="$t('Delegate to...')"
        lazy
        show-confirm-button
        @confirm="saveDelegatedUsers"
    >
        <template v-slot="{ on }">
            <slot :on="on" />
        </template>
        <template v-if="isSameAccount !== true" v-slot:content>
            <v-card
                class="px-3 py-2"
            >
                {{ $t("Please select tasks from the same account") }}
            </v-card>
        </template>
    </DropMenu>
</template>

<script>
import { ref, computed, watch } from "@vue/composition-api";
import AppModule from "../store/modules/app";
import TaskModule from "@/store/modules/task";
import UserModule from "@/store/modules/user";
import DropMenu from "./NewFilterBar/components/DropMenu";

export default {
    name: "BulkActionDelegate",
    components: {
        DropMenu
    },
    props: {
        tasks: {
            type: Array,
            default: null
        }
    },
    setup() {
        const menuOpen = ref(false);
        const search_person_name = ref(null);
        const appModule = AppModule();
        const userModule = UserModule();
        const {
            isSameAccount,
            selectedAccountId,
            setTasksAssignees,
            selectedListIds
        } = TaskModule();

        const users = computed(() => {
            let userList = userModule.getVisibleMembersByCompany(selectedAccountId.value)

            return userList.sort(function(a, b) {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            });
        });

        async function saveDelegatedUsers(selectedUsers) {
            if (selectedUsers.length === 0) {
                selectedListIds.value = [];
                menuOpen.value = false;
                return;
            }

            const selectedUserIds = selectedUsers.map(x => x.id);
            await setTasksAssignees(selectedUserIds);

            selectedListIds.value = [];
        }

        return {
            menuOpen,
            search_person_name,
            users,
            isSameAccount,
            saveDelegatedUsers,
        };
    }
};
</script>
